// src/pages/income/_shared/incomeDraftConfig.js
// ✅ 수입데이터+수입기안 통합 작성 — 지출 쪽 expenseDraftConfig.js와 동일한 패턴.
// IncomeDraftNew/List/DetailModal/PreviewWindow가 사업마다 달라지는 부분을 이
// config 객체 하나로 받는다. 각 사업 폴더는 이 팩토리로 자기 config를 만들고, 4종
// 컴포넌트에 그대로 넘기는 얇은 래퍼 파일만 갖는다.
//
// 지출과의 차이: 품목/인건비/다중거래처 패널이 없다(수입은 거래처 1곳 + 금액 단건이
// 기본형). 대신 categories(수입 종류, subcategory 값)만 사업별로 다르고, 거래처
// 자동완성은 partnerApiBase(사업마다 Partner 모델이 다름 — income.Partner 또는
// vendor_app.Vendor)로 받는다.
export function makeIncomeDraftConfig({
  namespace,
  category,
  businessLabel,
  // ✅ 브라우저 탭 제목(document.title)·AppLayout 탭 제목용 짧은 사업명(예: "소독").
  // businessLabel("환경/소독")과 별개로 두는 이유는 AppLayout.jsx TITLE_MAP이
  // "수입기안 - 소독" 형태의 짧은 규칙을 쓰기 때문(길게 쓰면 탭이 넓어짐).
  tabTitle,
  // ✅ DraftDocument.draft_no 조립용 접두어(예: "금천일자리(주)경영") — /draft/documents/
  // next-seq/ 로 받은 seq와 합쳐 클라이언트가 미리 표시·전송한다(지출 쪽과 동일 관례).
  // 수입 데이터 자체의 draft_no는 서버(combined_create의 draft_no_builder)가 별도로
  // 권위 있게 채번하므로 이 값과 반드시 일치할 필요는 없다.
  draftNoPrefix,
  dataApiBase,
  combinedCreateApi,
  newRoutePath,
  listRoutePath,
  previewRoutePath,
  categories,
  partnerApiBase = "/partners/",
  otherCategoryLabel = "기타",
  // ✅ 환경/종합 "냉난방기 종합세척"처럼 종류별 전용 상세내역 입력이 필요한 사업만
  // 쓰는 opt-in 훅 — DetailPanel(예: AircondDetailPanel)과, 그 패널을 보여줄 종류
  // 값 목록(detailPanelCategories). 대부분 사업은 둘 다 생략(패널 없음).
  DetailPanel = null,
  detailPanelCategories = [],
  // ✅ combined_create 페이로드에서 DetailPanel 행들을 담을 필드명(예: "aircond_details").
  detailPanelPayloadKey = null,
  // ✅ 환경/소독 "소독방역"처럼 종류를 고르면 붙임 행이 자동으로 채워져야 하는 사업만
  // 쓰는 opt-in 맵 { [종류값]: [{name, count}] }. 사용자가 일반 붙임 행과 동일하게
  // 수정·삭제 가능(자동 첨부되는 실제 파일 자체는 서버 post_create가 별도 처리).
  defaultAttachmentsByCategory = {},
  // ✅ 환경/소독처럼 "{거래처} {세부구분} {N}월분 대금청구 건" 자동 제목 조립이
  // 필요한 사업만 true로 켠다(구버전 draft_document/DraftDocumentNew.jsx의
  // 대금청구 전용 제목 스펙 재현). 기본은 false — 켜지 않은 사업은 기존처럼
  // "종류 선택" 시점의 단순 기본 제목을 그대로 쓴다(회귀 없음).
  useClaimTitleTemplate = false,
}) {
  return {
    namespace,
    category,
    businessLabel,
    tabTitle,
    draftNoPrefix,
    dataApiBase,
    combinedCreateApi,
    newRoutePath,
    listRoutePath,
    previewRoutePath,
    categories,
    partnerApiBase,
    otherCategoryLabel,
    DetailPanel,
    detailPanelCategories,
    detailPanelPayloadKey,
    defaultAttachmentsByCategory,
    useClaimTitleTemplate,
    // ✅ 파생값 — 사업마다 자동으로 고유해지도록 namespace로부터 조립(지출과 동일 관례).
    previewStorageKey: `${namespace}PreviewData`,
    previewChannelName: `${namespace}-preview`,
    listRefreshChannelName: `${namespace}-list-refresh`,
    previewWindowName: `${namespace.replace(/-/g, "")}Preview`,
  };
}
